var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 381.82 436.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".gradient{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 78.11,
    y1: 57.37,
    x2: 300.74,
    y2: 375.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f2e44c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a13065"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "base-line",
    d: "M190.91,437a12.77,12.77,0,0,1-6.38-1.71L6.38,332.38A12.75,12.75,0,0,1,0,321.33V115.62a12.75,12.75,0,0,1,6.38-11.05L184.53,1.71a12.76,12.76,0,0,1,12.76,0L375.44,104.57a12.75,12.75,0,0,1,6.38,11.05V321.33a12.75,12.75,0,0,1-6.38,11.05L197.29,435.24A12.77,12.77,0,0,1,190.91,437ZM25.51,314l165.4,95.49L356.31,314V123L190.91,27.49,25.51,123Zm343.55,7.36h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "gradient",
    d: "M190.9,437a12.7,12.7,0,0,1-6.37-1.71L6.38,332.38A12.75,12.75,0,0,1,0,321.33V115.62a12.76,12.76,0,0,1,19.13-11.05l171.78,99.17,152.64-88.12-159-91.81a12.76,12.76,0,1,1,12.76-22.1L375.44,104.57a12.75,12.75,0,0,1,0,22.09L197.29,229.52a12.76,12.76,0,0,1-12.76,0l-159-91.81V314l171.78,99.17A12.76,12.76,0,0,1,190.9,437Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a71c6ed7d0eae8bfde50303f94310490.svg";
export { ForwardRef as ReactComponent };